import React, { useEffect } from "react";
import Aos from "aos";
import 'aos/dist/aos.css';
import { PAGE_53 } from "./assets";
import styles from './BoardAnimation3.module.scss'; 
import { user1_bg_active } from "./assets/page_53";

export default function BoardAnimation() {

    useEffect(() => {
        Aos.init(); 
    }, []); 
    const users=[
        {
            bg:PAGE_53.user1_bg,
            bg_active:PAGE_53.user1_bg_active,
            instange:'',
            twitter:'https://twitter.com/_fujiyona/status/1470666133636546562?s=20',
            date:new Date("2021-12-14 16:00")
        },
        {
            bg:PAGE_53.user2_bg,
            bg_active:PAGE_53.user2_bg_active,
            instange:'https://www.instagram.com/sasakura_an/',
            twitter:'https://twitter.com/sasakura_an/status/1471753204686012421?s=20',
            date:new Date("2021-12-17 16:10")
        }
        ,
        {
            bg:PAGE_53.user3_bg,
            bg_active:PAGE_53.user3_bg_active,
            instange:'',
            twitter:'https://twitter.com/karenchandayoo',
            date:new Date("2021-12-21 16:30")
        }
        ,
        {
            bg:PAGE_53.user4_bg,
            bg_active:PAGE_53.user4_bg_active,
            instange:'',
            twitter:'https://twitter.com/TS_takasho/status/1474291387805798403?s=20',
            date:new Date("2021-12-24 16:30")
        }
        ,
        {
            bg:PAGE_53.user5_bg,
            bg_active:PAGE_53.user5_bg_active,
            instange:'',
            twitter:'https://twitter.com/meruishihara/status/1475744574345981954?s=20',
            date:new Date("2021-12-28 16:30")
        }
        ,
        {
            bg:PAGE_53.user6_bg,
            bg_active:PAGE_53.user6_bg_active,
            instange:'',
            twitter:'https://twitter.com/nagisa_micky/status/1476827597724352512?s=20',
            date:new Date("2021-12-31 16:30")
        }
        ,
        {
            bg:PAGE_53.user7_bg,
            bg_active:PAGE_53.user7_bg_active,
            instange:'',
            twitter:'https://twitter.com/aiga_mizuki/status/1478292669143318531?s=20',
            date:new Date("2022-1-4 16:30")
        }
        ,
        {
            bg:PAGE_53.user8_bg,
            bg_active:PAGE_53.user8_bg_active,
            instange:'',
            twitter:'https://twitter.com/momo_asu/status/1479428125071413248?s=20',
            date:new Date("2022-1-7 16:30")
        } ,
        {
            bg:PAGE_53.user9_bg,
            bg_active:PAGE_53.user9_bg_active,
            instange:'',
            twitter:'https://twitter.com/wakamiyahazuki/status/1481917172062380032?s=20',
            date:new Date("2022-1-14 16:30")
        }
    ]
    const getTwitterHref=function (user){
    return  user.date < new Date() && user.twitter.length>0?  user.twitter:"javascript:void(0)";
    }
    const getInstangeHref=function(user){
    return  user.date < new Date() && user.instange.length>0?  user.instange:"javascript:void(0)";
    }
 

    return (
        <div className={styles["container"]}>
            <div className={styles["top-board"]} data-aos="zoom-in" data-aos-duration="500">
                <img src={PAGE_53.BOX_3_Title.default} alt="title" />
            </div>
            <div className={styles["top-tip"]} data-aos="zoom-in" data-aos-duration="500">
                <img src={PAGE_53.tip.default} alt="tip" />
            </div>
            <div className={styles["bottom-board"]} data-aos="zoom-in" data-aos-duration="500">
                <img src={PAGE_53.BOX_3.default} alt="back" />
            </div>
            <div className={styles["right-character"]} data-aos="fade-right" data-aos-duration="1000">
                <img src={PAGE_53.RIGHT_CHARACTER.default} alt="Right character" />
            </div>
            <div className={styles["left-character"]} data-aos="fade-left" data-aos-duration="1000">
                <img src={PAGE_53.LEFT_CHARACTER.default} alt="Left character" />
            </div>
            <div className={styles["nvyou-panel"]}>
                {
                    users.map((item)=>{
                        return (
                            <div className={styles["nvyou"]}>
                            <img src={item.date<new Date()? item.bg_active.default:item.bg.default} alt="user1_bg" />
                            <div className={styles["nvyou-btns"]}>
                                <div>
                                   {
                                       item.date<new Date() && item.instange.length>0?(
                                        <a target={item.date<new Date() && item.instange.length>0?"_blank":"_self"} href={getInstangeHref(item)} rel="noreferrer"><img src={item.date<new Date() && item.instange.length>0 ?PAGE_53.instange_active.default:PAGE_53.instange.default} alt="instange" /></a>
                                       ):(
                                       <img src={item.date<new Date() && item.instange.length>0 ?PAGE_53.instange_active.default:PAGE_53.instange.default} alt="instange" />
                                       )
                                   }
                                </div>

                                <div>
                                    {
                                        item.date<new Date() && item.twitter.length>0?(
                                            <a target={item.date<new Date() && item.twitter.length>0?"_blank":"_self"}  href={getTwitterHref(item)} rel="noreferrer"><img src={item.date<new Date()&& item.twitter.length>0 ?PAGE_53.twitter_active.default:PAGE_53.twitter.default} alt="instange" /></a>
                                        ):(
                                         <img src={item.date<new Date()&& item.twitter.length>0 ?PAGE_53.twitter_active.default:PAGE_53.twitter.default} alt="instange" />
                                        )
                                    }
                                  </div>
                            </div>
                        </div>
                        )
                    })
                }
               
            </div>
        </div>
    )
}